export default "__VITE_ASSET__CQiB2hke__"